export const AUTO_HIDE_DURATION = 6300;
export const AUTO_HIDE_DURATION_TEN_SECOND = 10000;
export const MAX_SNACK = 3;

export { default as SnackbarsCustomStyle } from "./SnackbarsCustom";
export { default as SnackbarsActions } from "./SnackbarsActions";
export { default as SnackbarsContent } from "./SnackbarsContent";
